module.exports = __webpack_public_path__ + "static/media/12.48922e1b.png";